import DgDrawer from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgDrawer.install = function (Vue) {
  Vue.component(DgDrawer.name, DgDrawer)
}
export default DgDrawer

export { DgDrawer }